// react
import React, { useEffect, useContext } from 'react';
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

// material-ui icons
import CreditCard from "@material-ui/icons/CreditCard";
import Subtitles from "@material-ui/icons/Subtitles";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Event from "@material-ui/icons/Event";
import Grade from "@material-ui/icons/Grade";
import PixIcon from "@mui/icons-material/Pix";

// material-ui components
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import HeaderProcessoFinal from "beaktClinic/views/Venda/Header/HeaderProcessoFinal";
import PagamentoCartao from "beaktClinic/views/Venda/Pagamentos/PagamentoCartao";
import PagamentoDinheiro from "beaktClinic/views/Venda/Pagamentos/PagamentoDinheiro";
import PagamentoCheque from "beaktClinic/views/Venda/Pagamentos/PagamentoCheque";
import PagamentoBoleto from "beaktClinic/views/Venda/Pagamentos/PagamentoBoleto";
import PagamentoOutros from "beaktClinic/views/Venda/Pagamentos/PagamentoOutros";
import PagamentoPix from "beaktClinic/views/Venda/Pagamentos/PagamentoPix";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext, getLanguageSelected } from "beaktShared/services/session";
import { setcarrinhoVendaCookie, getcarrinhoVendaCookie, setResultadoVendaCookie } from "beaktClinic/services/carrinhoVenda";
import { transformValueFormatedtoFloat, transformValueFloattoFormated } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoVenda.js";
const useStyles = makeStyles(styles);

export default function PagamentoVenda({history}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const session = useContext(SessionContext);
  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });
  
  const [listaFormasPagamento, setlistaFormasPagamento] = React.useState([]);
  const [tabsPagamento, settabsPagamento] = React.useState([]);

  const [loadCarrinho, setloadCarrinho] = React.useState(getcarrinhoVendaCookie());  
  const [pgto, setpgto] = React.useState({
    pagamentos:[],
    totalizadorPagamentos:{
      valorTotalPago: 0,
      valorPendente:0,
    }
  });  
        
  useEffect(() => {       
    if(loadCarrinho.itens.length === 0)    
      history.push("/adminclinic/venda"); 
         
    loadFormasPagamento();
  }, []);

  useEffect(() => {          
    setmessageFinalizaReturn({show:false})
    loadTabsFormasPagamento();
  }, [pgto]);
    
  const loadTotalizadorPgtos = (pgto) =>
  {
    let valorPago = 0;
    pgto.pagamentos.map(item =>{
      valorPago = valorPago + item.valor;
    });

    let valorSaldoPendente = loadCarrinho.totalizadorItens.TotalItensComDesconto.toFixed(2) - valorPago.toFixed(2);
    
    let updatepgto ={
      ...pgto,        
      totalizadorPagamentos:{
        valorTotalPago: valorPago,
        valorPendente:valorSaldoPendente,
      }
    };
    
    setpgto(updatepgto);
    return updatepgto;
  };

  const handleRemovePg = (item) => {
    if (item.descricaoFormaPgto === 'PIX Integrado')
    {
       setalert(
        <SweetAlert
          warning={true}            
          title={t('label.attention')}
          showConfirm={true}
          showCancel={true}
          confirmBtnText={t('label.confirm')}
          cancelBtnText={t('button.cancel')}
          cancelBtnBsStyle={"secondary"}
          confirmBtnBsStyle={"danger"}
          onConfirm={() => PostCancelamentoPix(item)}
          onCancel={() => setalert(null)}
        >
          <span>
            Deseja cancelar o recebimento PIX? 
            Esta confirmação ira estornar o valor recebido 
            para a conta do cliente.
          </span>
        </SweetAlert>
      );
    }
    else
    {
      let listFiltered = pgto.pagamentos.filter(obj => {
          return obj.id !== item.id;
      });
      
      let updatepgto = {
          ...pgto,
          pagamentos: listFiltered
      }    
    
      loadTotalizadorPgtos(updatepgto);
    }
  };

  const loadPaymentExamples = () =>{
    let pg =
    {
      id:0,
      tipo:0, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
      valor:200,
      descTipo: 'Dinheiro',
      parcela:'',
      descPacela:'à vista'
    }
    let pg2 =
    {
      id:1,
      tipo:1, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
      valor:1548.20,
      descTipo: 'Cartão de crédito VISA final 2938 / Autorização 23433',
      parcela:'2',
      descPacela:'2x 587,10'
    }
    setloadCarrinho({
      ...loadCarrinho,
      pagamentos:[pg,pg2]
    });
  };

  const [loadingPayments,setloadingPayments] = React.useState(false);
  const loadFormasPagamento = () => {          
    setloadingPayments(true);
    UseGetApiSimple("formaPagamentos/ativos/byestabelecimento/" + session.estabelecimentoId).then(result => 
    {
      if(result.status !== 200)
      {                             
        setmessageReturn({
          show:true,
          message:'Não foi possível carregar as formas de pagamento!'
        });    
        setloadingPayments(false);
        return false; 
      }
      setlistaFormasPagamento(result.data);
      loadTotalizadorPgtos(pgto);
      setloadingPayments(false);
    }); 
  };

  const loadTabsFormasPagamento = () => {
    let tabs = [];
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 1).length > 0){
        tabs.push({                    
          tabButton: t('sale.card'),
          tabIcon: CreditCard,
          tabContent: (
            <div>
              <PagamentoCartao 
                CallloadTotalizadorPgtosCt={loadTotalizadorPgtos} 
                pgto={pgto} 
                formasCartao={listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 1)}>
              </PagamentoCartao>
            </div>
          )
        });
      }
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 5).length > 0) // PIX Integrado
      {
        tabs.push({
          tabButton: 'PIX',
          tabIcon: PixIcon,
          tabContent: (
            <>
              <PagamentoPix
                CallloadTotalizadorPgtos={loadTotalizadorPgtos} 
                pgto={pgto}
                clienteId={loadCarrinho.clienteId}>
              </PagamentoPix>
            </>
          )
        });
      }
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 0).length > 0){
        tabs.push({
          tabButton: t('sale.money'),
          tabIcon: AttachMoney,
          tabContent: (
            <div>
              <PagamentoDinheiro 
                CallloadTotalizadorPgtos={loadTotalizadorPgtos} 
                pgto={pgto}>
              </PagamentoDinheiro>
            </div>
          )
        });
      }
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 2).length > 0){
        tabs.push({
          tabButton: t('sale.billet'),
          tabIcon: Event,
          tabContent: (
          <div>
            <PagamentoBoleto CallloadTotalizadorPgtosBo={loadTotalizadorPgtos} pgto={pgto}></PagamentoBoleto>
          </div>
          )          
        });
      }
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 3).length > 0){
        tabs.push({
          tabButton: t('sale.check'),
          tabIcon: Subtitles,
          tabContent: (
          <div>
            <PagamentoCheque CallloadTotalizadorPgtosCq={loadTotalizadorPgtos} pgto={pgto}></PagamentoCheque>
          </div>
          )
        });
      }
      if (listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 4).length > 0){
        tabs.push({
          tabButton: t('sale.others'),
          tabIcon: Grade,
          tabContent: (
           <div>
             <PagamentoOutros CallloadTotalizadorPgtosOutros={loadTotalizadorPgtos} pgto={pgto} formaOutros={listaFormasPagamento.filter(({tipoFormaPagamento}) => tipoFormaPagamento === 4)}></PagamentoOutros>
           </div>
          )
        });
      }
      settabsPagamento(tabs);
  }

  const [messageFinalizaReturn,setmessageFinalizaReturn]= React.useState({
    show:false,
    message:''
  });

  const [loadComplete, setloadComplete] = React.useState(false); 
  const handleFinalizaVenda = () => {
    if (loadComplete) return;
    setloadComplete(true);
    if(pgto.totalizadorPagamentos.valorPendente !== 0)
    {
      setmessageFinalizaReturn({
        show:true,
        message:'O valor de Saldo a Pagar deverá ser zerado!'
      }); 
      setloadComplete(false);
      return false;
    }

    let carrinhoSend = {
      ...loadCarrinho,      
      ...pgto      
    }

    try
    {
      let language = getLanguageSelected();
        if(language === 'pt')
          carrinhoSend.Locale = "pt-BR";
        else
          carrinhoSend.Locale = "en-US";
    }
    catch { }

    let endPoint = "vendas/";
    UsePostApi(endPoint, carrinhoSend).then(result=>{
        if (result.status !== 200)
        {                                     
            showAlert(result.message.message,'warning');
            setloadComplete(false);  
            return false; 
        }
        setcarrinhoVendaCookie(null);
        setResultadoVendaCookie(result.data);
        history.push("/adminclinic/finalizacaovenda");
        setloadComplete(false);
        return true;                        
    });     
  };

  const [alert,setalert] = React.useState();

  const showAlert = (message, tipo) => {
    setalert(<SweetAlert
      warning={tipo=='warning'?true:false}
      success={tipo=='success'?true:false}
      title="Aviso"
      onConfirm={() => hideAlert()}
    >  
    <div dangerouslySetInnerHTML={{ __html: message}} /> 
    </SweetAlert> );
  };

  const hideAlert = () => {
    setalert(null);
    setTimeout(function () {
      setmessageReturn({ show: false });
    }, 5000);
  };

  const handleExcluirVenda = () =>{
    if(pgto.totalizadorPagamentos.valorTotalPago > 0)
    {
      setmessageFinalizaReturn({
        show:true,
        message:'Só é possível excluir venda sem pagamento registrado!'
      }); 
      return false;
    }

    setcarrinhoVendaCookie(null);
    history.push("/adminclinic/venda");
    return true; 
  };

  const endPointPix = "beaktPaymentPixIntegrado/";
  const PostCancelamentoPix = (item) => {
    setloadingPayments(true);
    let orderId = item?.orderId;
    let amount = item?.valor;
    
    let sendCancelQRCode = {
      order_id: orderId,
      valor: amount,
    }

    let requestCancelQRCode = {
        SendCancelQRCode: sendCancelQRCode,
        EstabelecimentoId: session.estabelecimentoId
    }

    UsePostApi(endPointPix + 'cancelQRCode', requestCancelQRCode).then(result => 
    {
      if (result.status !== 200) 
      {
          setmessageReturn({
            show: true,
            message:'Erro ao cancelar QRCode do pagamento PIX. ' + result.message
          }); 
          setloadingPayments(false);
          hideAlert();
          return false;
      }
      else
      {
          setmessageReturn({
            show: true,
            message:'QRCode do pagamento PIX cancelado com sucesso.'
          });
          let listFiltered = pgto.pagamentos.filter(obj => {
            return obj.id !== item.id;
          });
          let updatepgto = {
              ...pgto,
              pagamentos: listFiltered
          }
          loadTotalizadorPgtos(updatepgto);
          hideAlert();
          setloadingPayments(false);
      }
    });
  };
    
return (    
    <div className="maxContent">    

        {loadComplete && 
          <div className="carregandoCmp">
              <div className="box">
                <label>{t('label.loading')}...</label>
                <CircularProgress />
              </div>
          </div> 
        }        
        
        {alert}

        <HeaderProcessoFinal etapa={2}></HeaderProcessoFinal>

        <GridContainer>
           
            <GridItem xs={12} sm={8} md={8}>
            <Card>
            <CardBody>    
               
               <h3>{t('sale.payment_methods')}</h3>

              <div style={{ maxWidth:'700px', margin:'0 auto' }}>
                {
                  loadingPayments && 
                  <div style={{textAlign:'center',paddingTop:'100px'}}>
                    <CircularProgress />
                    <br/>
                    <label>{t('label.loading')}...</label>
                  </div>
                } 
                <NavPills
                  color="primary"
                  alignCenter
                  tabs={tabsPagamento}
                />
              </div>
              {messageReturn.show &&
                <div><div className="alertErrorEx alertmax">
                  <p>
                  {messageReturn.message}   
                  </p>
                </div><br/></div>
              }
            </CardBody>
            </Card>  
            </GridItem>            
            <GridItem xs={12} sm={4} md={4}>
            <Card>
            <CardBody>    
               
               <h4>{t('sale.payments_made')}</h4>

               {pgto.pagamentos.map(item => (  
                 <div key={item.id}> 
                   <div className={classes.boxItemPg}>
                      <div className={classes.descForma}>
                        {item.descTipo}
                      </div>
                      <div className={classes.valuePg}>
                        <small>{t('label.money_symbol')}</small> {transformValueFloattoFormated(item.valor)} - <small> {item.descPacela}</small>  
                      </div>                                      
                      <div className={classes.rmvPg}>
                      <a  href="#"  onClick={() => handleRemovePg(item)}>
                        {t('button.remove')}
                      </a>
                      </div>               
                    </div> 
                    <br/>  
                    </div> 
                ))}
                
                <br/>
              <div className={classes.boxTotalizador}>
                {t('sale.total_sale')}
                <div className={classes.valueTotalizador}>
                {t('label.money_symbol')} {transformValueFloattoFormated(loadCarrinho.totalizadorItens.TotalItensComDesconto)} 
                </div>
                <Clearfix/>
              </div>
              <div className={classes.boxTotalizador}>
                {t('sale.total_payments')} 
                <div className={classes.valueTotalizador}>
                {t('label.money_symbol')} {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorTotalPago)} 
                </div>
                <Clearfix/>
              </div>
              <div className={classes.boxPendencia}>
                {t('sale.balance_to_pay')}  
                <div className={classes.valuePendencia}>
                {t('label.money_symbol')} {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente)} 
                </div>
              </div>  
                           

              <GridItem xs={12} sm={12} md={12}>
                <br/>
                
                {messageFinalizaReturn.show &&
                 <div><div className="alertErrorEx alertmax">
                    <p>
                    {messageFinalizaReturn.message}   
                    </p>
                 </div><br/>
                 </div>
                }
                
                <div className={classes.tCenter}>

                {pgto.pagamentos.length === 0 &&
                <Button fullWidth
                onClick={() => handleExcluirVenda()}>
                   {t('sale.delete_sale')}                       
                </Button>
                }
                
                <Link to="/adminclinic/finalizacaovenda" > 
                </Link>
                <Button 
                  fullWidth 
                  color="info" 
                  onClick={() => handleFinalizaVenda()}
                  disabled={loadComplete}
                >
                   {t('sale.finish_sale')}                       
                </Button>

                </div>
              </GridItem>
              
            </CardBody>
            </Card>  
            </GridItem>

        </GridContainer>
    </div>
);
}